import React from 'react';
import { Box, BoxProps } from '@mui/material';
import landscapePlaceholder from 'assets/images/landscape-placeholder.svg';

export const CHAT_IMAGE_BROKEN_PLACEHOLDER = landscapePlaceholder;

export type ChatImageWithFallbackProps = Omit<BoxProps<'img'>, 'component' | 'src'> & {
  src?: string | null;
};

/**
 * Renders an image in chat; on load error or missing src, shows the bundled landscape placeholder.
 */
const ChatImageWithFallback = React.forwardRef<HTMLImageElement, ChatImageWithFallbackProps>(
  function ChatImageWithFallback({ src, onError, sx, alt = '', ...rest }, ref) {
    const [displaySrc, setDisplaySrc] = React.useState(() => src || landscapePlaceholder);

    React.useEffect(() => {
      setDisplaySrc(src || landscapePlaceholder);
    }, [src]);

    return (
      <Box
        component="img"
        ref={ref}
        src={displaySrc}
        alt={alt}
        onError={(e) => {
          setDisplaySrc((prev) => (prev !== landscapePlaceholder ? landscapePlaceholder : prev));
          onError?.(e);
        }}
        sx={sx}
        {...rest}
      />
    );
  },
);

export default ChatImageWithFallback;
